<script>
import ContactInfoRow from './ContactInfoRow.vue';
export default {
  components: {
    ContactInfoRow,
  },
  props: {
    extraAdds: {
      type: Object,
      default: () => ({}),
      required: true,
    },
  },
  mounted() {},
};
</script>

<template>
  <div>
    <ContactInfoRow
      v-if="extraAdds.cpf"
      :value="extraAdds.cpf.value"
      icon="contact-identify"
      emoji="🪪"
      title="CPF"
      href="#"
      show-copy
    />
  </div>
</template>
